import { FunctionComponent } from "react";
import Select, { MultiValue } from "react-select";
import { TVChannel } from "../../../../api/tvChannelApi";
import { Button } from "../../../components/Button";

interface Props {
    tvChannelsList: TVChannel[];
    selectedChannels: TVChannel[];
    setSelectedChannels: (channels: TVChannel[]) => void;
    selectedDate: string;
    setSelectedDate: (date: string) => void;
    programName: string;
    setProgramName: (name: string) => void;
    onSearch: () => void;
}

const channelPresets: { label: string; keywords: string[] }[] = [
    { label: 'All Sky Sports', keywords: ['sky sports'] },
    { label: 'All Sky Cinema', keywords: ['sky cinema'] },
    { label: 'All Sky News', keywords: ['sky news'] },
];

const ChannelSearchFilters: FunctionComponent<Props> = ({
    tvChannelsList, 
    selectedChannels, setSelectedChannels,
    selectedDate, setSelectedDate,
    programName, setProgramName,
    onSearch,
}) => (
    <div className="d-flex align-items-end gap15 mb-20 w-100">
        <div style={{ flex: 2 }}>
            <div className="d-flex gap5 mb-5" style={{ flexWrap: 'wrap' }}>
                {channelPresets.map(preset => (
                    <Button
                        key={preset.label}
                        color="green"
                        label={preset.label}
                        onClick={() => {
                            const matched = tvChannelsList.filter(ch => preset.keywords.some(kw => ch.name.toLowerCase().includes(kw)));
                            const merged = [...selectedChannels];
                            matched.forEach(ch => { if (!merged.some(s => s.id === ch.id)) merged.push(ch); });
                            setSelectedChannels(merged);
                        }}
                    />
                ))}
            </div>
            <Select
                classNamePrefix="select"
                isMulti={true}
                isClearable={true}
                options={tvChannelsList}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                onChange={(v: MultiValue<TVChannel>) => setSelectedChannels([...v])}
                value={selectedChannels}
            />
        </div>
        <div style={{ flex: 1 }}>
            <label className="form-label">Date</label>
            <input
                className="form-control"
                type="date"
                value={selectedDate}
                onChange={e => setSelectedDate(e.target.value)}
            />
        </div>
        <div style={{ flex: 1 }}>
            <label className="form-label">Program Name</label>
            <input
                className="form-control"
                type="text"
                placeholder="Program name"
                value={programName}
                onChange={e => setProgramName(e.target.value)}
            />
        </div>
        <div className="d-flex align-items-end">
            <Button color="green" label="Search" onClick={onSearch} />
        </div>
    </div>
);

export default ChannelSearchFilters;
